module.exports = __webpack_public_path__ + "static/media/sand-storm.ed7caa49.svg";